import Leger from "../../../../../components/categories/siakad/laporan_adab/leger_sync/Home"
export default function Home() {
  
  return (
    <Leger />
  );
}
